const loadImage = (src) =>
  new Promise((resolve) => {
    if (!src) return resolve(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });

const drawCircleImage = (ctx, img, cx, cy, r, ring) => {
  ctx.save();
  ctx.shadowColor = ring;
  ctx.shadowBlur = 50;
  ctx.beginPath();
  ctx.arc(cx, cy, r + 6, 0, Math.PI * 2);
  ctx.fillStyle = ring;
  ctx.fill();
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.clip();
  ctx.fillStyle = "#14102a";
  ctx.fillRect(cx - r, cy - r, r * 2, r * 2);
  if (img) {
    const s = Math.min(img.width, img.height);
    ctx.drawImage(img, (img.width - s) / 2, (img.height - s) / 4, s, s, cx - r, cy - r, r * 2, r * 2);
  }
  ctx.restore();
};

const wrapLines = (ctx, text, maxWidth, maxLines) => {
  const words = text.split(/\s+/);
  const lines = [];
  let line = "";
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = w;
    } else line = test;
  }
  if (line) lines.push(line);
  if (lines.length > maxLines) {
    const cut = lines.slice(0, maxLines);
    cut[maxLines - 1] = cut[maxLines - 1].replace(/\s*\S*$/, "") + "…";
    return cut;
  }
  return lines;
};

export const downloadFutureCard = async ({ todayUrl, futureUrl, message, ageLabel, name }) => {
  const W = 1080;
  const H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  await document.fonts?.ready;

  ctx.fillStyle = "#05050A";
  ctx.fillRect(0, 0, W, H);
  [["rgba(176,38,255,0.28)", 200, 200], ["rgba(0,240,255,0.2)", 900, 1150], ["rgba(255,215,0,0.12)", 540, 520]].forEach(([c, x, y]) => {
    const g = ctx.createRadialGradient(x, y, 0, x, y, 600);
    g.addColorStop(0, c);
    g.addColorStop(1, "rgba(0,0,0,0)");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
  });
  ctx.fillStyle = "rgba(255,255,255,0.7)";
  for (let i = 0; i < 120; i++) ctx.fillRect(Math.random() * W, Math.random() * H, 1.5, 1.5);

  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "500 26px Outfit, sans-serif";
  ctx.fillText("L I F E   R A B B I T   H O L E", W / 2, 110);

  const [today, future] = await Promise.all([loadImage(todayUrl), loadImage(futureUrl)]);
  drawCircleImage(ctx, today, 330, 400, 170, "rgba(0,240,255,0.85)");
  drawCircleImage(ctx, future, 750, 400, 170, "rgba(255,215,0,0.85)");
  ctx.font = "600 30px Outfit, sans-serif";
  ctx.fillStyle = "#00F0FF";
  ctx.fillText("TODAY", 330, 640);
  ctx.fillStyle = "#FFD700";
  ctx.fillText((ageLabel || "FUTURE ME").toUpperCase(), 750, 640);

  ctx.fillStyle = "rgba(255,255,255,0.55)";
  ctx.font = "500 26px Outfit, sans-serif";
  ctx.fillText(name ? `A MESSAGE TO ${name.toUpperCase()}` : "A MESSAGE FROM FUTURE ME", W / 2, 740);

  ctx.fillStyle = "#FFFFFF";
  const top = 820;
  const bottom = H - 150;
  let size = 42;
  let lines;
  for (; size >= 26; size -= 2) {
    ctx.font = `300 ${size}px Outfit, sans-serif`;
    lines = wrapLines(ctx, `“${message}”`, 860, 99);
    if (lines.length * size * 1.33 <= bottom - top) break;
  }
  const lh = size * 1.33;
  lines = wrapLines(ctx, `“${message}”`, 860, Math.floor((bottom - top) / lh));
  lines.forEach((l, i) => ctx.fillText(l, W / 2, top + i * lh));

  ctx.fillStyle = "rgba(255,215,0,0.85)";
  ctx.font = "600 28px Outfit, sans-serif";
  ctx.fillText("One Life. Infinite Possibilities.", W / 2, H - 80);

  const a = document.createElement("a");
  a.download = "my-future-card.png";
  a.href = canvas.toDataURL("image/png");
  a.click();
};
